module.exports = __webpack_public_path__ + "img/btn.0a2cc680.png";